export const TimeWindowPreset = {
  Day: 'DAY',
  Week: 'WEEK',
  Month: 'MONTH',
} as const;

export type TimeWindowPreset =
  (typeof TimeWindowPreset)[keyof typeof TimeWindowPreset];

export function isTimeWindowPreset(value: string): value is TimeWindowPreset {
  return (Object.values(TimeWindowPreset) as string[]).includes(value);
}

export const TIME_WINDOW_ORDER: TimeWindowPreset[] = [
  TimeWindowPreset.Day,
  TimeWindowPreset.Week,
  TimeWindowPreset.Month,
];

export const TIME_WINDOW_LABELS: Record<TimeWindowPreset, string> = {
  [TimeWindowPreset.Day]: 'Last 24 hours',
  [TimeWindowPreset.Week]: 'Last 7 days',
  [TimeWindowPreset.Month]: 'Last 30 days',
};

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const TIME_WINDOW_DURATION_MILLISECONDS: Record<
  TimeWindowPreset,
  number
> = {
  [TimeWindowPreset.Day]: MILLISECONDS_PER_DAY,
  [TimeWindowPreset.Week]: 7 * MILLISECONDS_PER_DAY,
  [TimeWindowPreset.Month]: 30 * MILLISECONDS_PER_DAY,
};
